import { render, staticRenderFns } from "./AgentDetailsTabs.vue?vue&type=template&id=566e8300&lang=html"
import script from "./AgentDetailsTabs.vue?vue&type=script&lang=js"
export * from "./AgentDetailsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports